<template>
  <div id="app">
    <a href="#main-content" class="skip-link">{{ $t('common.skip_to_content') }}</a>
    <div v-if="useAppShell">
      <div id="main-wrapper">
        <Aside />
        <Header />
        <div id="main-content" class="page-wrapper" tabindex="-1">
          <router-view />
        </div>
      </div>
      <Floating />
    </div>
    <div v-else class="layout-light side-menu main-wrapper not-log-in">
      <main id="main-content" class="main-content" tabindex="-1">
        <router-view />
      </main>
    </div>
    <AppPromptHost />
  </div>
</template>

<script>
import Aside from '@/components/layouts/Aside.vue'
import Header from '@/components/layouts/Header.vue'
import Floating from '@/components/layouts/Floating.vue'
import AppPromptHost from '@/components/common/AppPromptHost.vue'

export default {
  components: { Aside, Header, Floating, AppPromptHost },
  computed: {
    isLoggedIn() {
      return this.$store.getters['auth/isLoggedIn']
    },
    useAppShell() {
      if (!this.isLoggedIn) return false
      const matched = this.$route.matched
      if (matched.some((record) => record.meta.publicDocs)) return true
      return !matched.some((record) => record.meta.standaloneLayout)
    },
  },
  watch: {
    '$route'() {
      setTimeout(() => this.initTemplate(), 300)
    },
    isLoggedIn() {
      this.initTemplate()
    },
  },
  mounted() {
    this.initTemplate()
  },
  methods: {
    initTemplate() {},
  },
}
</script>

<style>
.spinner { height: 1rem !important; width: 1rem !important; }
.vm--modal { height: auto !important; max-height: 95% !important; overflow-y: auto !important; position: fixed !important; }
hr { margin-top: 20px !important; margin-bottom: 20px !important; }
.not-log-in .main-content { min-height: 100vh; }
</style>
